import { useState, useEffect } from 'react';
import { getExperimentDetails } from '../utils/ExperimentUtils';
import { HIVEMIND_INELIGIBLE } from '../../constants/hivemind';

// bucket: cohort field from hivemind
// data: Optional JSON field from hivemind.
// isLoading: true while fetching experiment result
// error: returned when fail to fetch experiment

const useExperiment = url => {
  const [bucket, setBucket] = useState(null);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchExperimentDetails = async () => {
      try {
        const result = await getExperimentDetails(url);
        setBucket(result.cohortId);
        setData(result.data);
      } catch (err) {
        setBucket(HIVEMIND_INELIGIBLE);
        setError(err);
        console.error('Error fetching experiment details:', err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchExperimentDetails();
  }, [url]);

  return { bucket, data, isLoading, error };
};

export default useExperiment;
